import React from 'react'
import { HorizontalStack, IconValueBlock, TooltipPopOver } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'
import type { InlineInputDisplayContent, InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { BusyButtonLink, CopyToClipboardButton } from '@ztechapps/webui.button'

const displayContent: InlineInputDisplayContent = (initialValue, onClick) => (
  <TooltipPopOver tooltipBody="Product code">
    <HorizontalStack gap={4} className={' align-items-center'}>
      <IconValueBlock icon="barcode" value={initialValue} />
      <HorizontalStack gap={2}>
        <CopyToClipboardButton textToCopy={initialValue} />
        <BusyButtonLink icon="pencil" title="Edit product code" onClick={onClick} />
      </HorizontalStack>
    </HorizontalStack>
  </TooltipPopOver>
)

export const CodeInlineInput = (props: InlineInputProps) => {
  return (
    <InlineInput
      name={'code'}
      hoverToEdit={false}
      displayContent={(initialValue, onClick) => <h1 className={'m-0 '}>{displayContent(initialValue, onClick)}</h1>}
      validate={(e) => {
        if (isEmpty(e)) throw new Error('Required to have a value.')
      }}
      {...props}
    />
  )
}
CodeInlineInput.displayContent = displayContent
